export const ALLOWED_REGIONS = [
  'Colorado',
  'Connecticut',
  'District of Columbia',
  'Florida',
  'Idaho',
  'Illinois',
  'Iowa',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'New Jersey',
  'North Carolina',
  'Pennsylvania',
  'Rhode Island',
  'Washington'
];
